import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { client } from "src/utils/axios-client";
import { AIRole, AITone } from "../ai-chat-types";

export const ServerStateKey = ['ai-tone-list'];
export const apiUri = '/api/ai/chat/tones';

export const useGetAITones = () => useQuery<AITone[]>({
    queryKey: ServerStateKey,
    queryFn: () => client.get(apiUri, { params: {} }).then((res) => res.data),
    initialData: [],
    staleTime: 0,
});
